import UIFlex from 'UIComponents/layout/UIFlex';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIBox from 'UIComponents/layout/UIBox';
import * as colors from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FIRST_RESPONSE_SLA, NEXT_RESPONSE_SLA, CLOSE_TICKET_SLA, RESOLVED_IN_SLA, RESOLVED_OUT_OF_SLA } from 'conversations-thread-data/tickets/public/constants';
import { getIsSLAResolved } from 'conversations-thread-data/tickets/public/operators';
import { getColorHashForSLAIconFromStatus } from '../operators/getColorHashForSLAIconFromStatus';
import SLADetailsTime from './SLADetailsTime';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SLACategoryName = ({
  slaCatagory
}) => {
  switch (slaCatagory) {
    case FIRST_RESPONSE_SLA:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "svh-workspace-ui-lib.ticket-toolbar.SLAs.slaTypes.firstReply"
      });
    case CLOSE_TICKET_SLA:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "svh-workspace-ui-lib.ticket-toolbar.SLAs.slaTypes.timeToClose"
      });
    case NEXT_RESPONSE_SLA:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "svh-workspace-ui-lib.ticket-toolbar.SLAs.slaTypes.nextReply"
      });
    default:
      throw new Error(`SLACatagory ${slaCatagory} isn't one of the known types.`);
  }
};
SLACategoryName.displayName = 'SLACategoryName';
const getSuccessCheck = slaStatus => {
  switch (slaStatus) {
    case RESOLVED_IN_SLA:
      return /*#__PURE__*/_jsx(UIIcon, {
        name: "success",
        color: colors.OZ
      });
    case RESOLVED_OUT_OF_SLA:
      return /*#__PURE__*/_jsx(UIIcon, {
        name: "success",
        color: colors.MARIGOLD
      });
    default:
      throw new Error(`SLAStatus ${slaStatus} isn't one of the known types.`);
  }
};
const getCompletedMessage = slaStatus => {
  switch (slaStatus) {
    case RESOLVED_IN_SLA:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "svh-workspace-ui-lib.ticket-toolbar.SLAs.completed"
      });
    case RESOLVED_OUT_OF_SLA:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "svh-workspace-ui-lib.ticket-toolbar.SLAs.completedLate"
      });
    default:
      throw new Error(`SLAStatus ${slaStatus} isn't one of the known types.`);
  }
};
const SLADetailRow = ({
  slaDetails
}) => {
  const isSLAResolved = getIsSLAResolved(slaDetails.status);
  return /*#__PURE__*/_jsxs(UIFlex, {
    className: "m-top-3",
    justify: "between",
    align: "center",
    children: [/*#__PURE__*/_jsx(UIBox, {
      shrink: 0,
      style: {
        width: '17px'
      },
      children: isSLAResolved ? getSuccessCheck(slaDetails.status) : /*#__PURE__*/_jsx(UIIcon, {
        name: "time",
        size: "xxs",
        color: getColorHashForSLAIconFromStatus(slaDetails.status)
      })
    }), /*#__PURE__*/_jsx(UIBox, {
      className: "p-left-3 p-right-9",
      grow: 1,
      children: /*#__PURE__*/_jsx(SLACategoryName, {
        slaCatagory: slaDetails.category
      })
    }), /*#__PURE__*/_jsx(UIBox, {
      shrink: 0,
      children: isSLAResolved ? getCompletedMessage(slaDetails.status) : /*#__PURE__*/_jsx(SLADetailsTime, {
        dueDate: slaDetails.dueDate
      })
    })]
  });
};
SLADetailRow.displayName = 'SLADetailRow';
export default SLADetailRow;